<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-avatar, list-item-three-line, actions" class="mb-3"></v-skeleton-loader>
      <v-skeleton-loader type="table"></v-skeleton-loader>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Integradores
      </div>
      <v-data-table
        :headers="headers"
        :items="dados"
        :search="searchFinal"
        disable-sort
        class="elevation-1 base_table"
        :footer-props="{
          itemsPerPageOptions: [5,10,15,20,25,50,100],
          showFirstLastPage: true,
          firstIcon: 'skip_previous',
          lastIcon: 'skip_next',
          prevIcon: 'chevron_left',
          nextIcon: 'chevron_right'
        }"
        :header-props="{
          sortIcon: 'north',
        }"
      >
      <template v-slot:top>
        <v-row no-gutters align="center" justify="space-between">
          <div class="py-2 px-2">
            <v-row no-gutters>
              <v-form @submit.prevent="applyBusca()">
                <v-text-field
                  clearable
                  hide-details=""
                  clear-icon="close"
                  v-model="search"
                  outlined
                  label="Busca"
                  @click:clear="limparBusca()"
                ></v-text-field>
              </v-form>
              <v-autocomplete
                v-if="nivelUsuarioApelido === 'M'"
                class="ml-3"
                :menu-props="{ offsetY: true}"
                :items="distribuidores"
                label="Distribuidor"
                append-icon="expand_more"
                v-model="distribuidor"
                hide-details=""
                :loading="loading || loadingDistribuidores"
                :disabled="loading || loadingDistribuidores"
                outlined
                @click:clear="applyFilter()"
                clearable
                clear-icon="close"
                @change="applyFilter()"
              ></v-autocomplete>
            </v-row>
          </div>
            <div>
              <v-menu
                bottom
                center
                offset-y
                max-height="400"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on">
                    Exportar
                    <v-icon>arrow_drop_down</v-icon>
                  </div>
                </template>
                <v-list>
                  <v-list-item @click="exportXls()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">receipt_long</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para XLS</v-list-item-title>
                  </v-list-item>
                  <!-- <v-list-item @click="exportPdf()">
                    <v-list-item-icon class="mr-1">
                      <v-icon color="primary">assignment</v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>Exportar para PDF</v-list-item-title>
                  </v-list-item> -->
                </v-list>
              </v-menu>
            </div>
          </v-row>
        </template>
        <template v-slot:item.api="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openAPIS(item)" color="primary" class="ml-2">
                open_with
              </v-icon>
            </template>
            <span>API</span>
          </v-tooltip>
        </template>
        <template v-slot:item.users="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="openUsuarios(item)" color="primary" class="ml-2">
                group
              </v-icon>
            </template>
            <span>Usuários</span>
          </v-tooltip>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-row no-gutters align="center" justify="center">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openIntegrador(item)" color="primary" class="mr-2" :disabled="salvando">
                  edit
                </v-icon>
              </template>
              <span>Editar integrador</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="openDialogDelete(item)" color="primary" class="ml-2">
                  delete
                </v-icon>
              </template>
              <span>Excluir integrador</span>
            </v-tooltip>
          </v-row>
        </template>
      </v-data-table>
    </div>
    <div class="ui-create">
      <v-btn color="primary" elevation="3" @click="dialogNovo = true" :loading="loading" :disabled="loading">
        <v-icon color="white" x-large>add</v-icon>
      </v-btn>
    </div>
    <v-dialog
      v-model="dialogNovo"
      persistent
      max-width="900px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{integrador.uuid_int_id ? 'Editar' : 'Novo'}} integrador
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialog()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formIntegrador">
          <v-row>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="integrador.uuid_dis_id"
                :items="distribuidores"
                clearable
                clear-icon="close"
                label="Distribuidor*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingDistribuidores"
                :disabled="salvando || loadingDistribuidores"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-text-field
                v-model="integrador.int_nome"
                autofocus
                label="Razão social*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0">
              <v-text-field
                v-model="integrador.int_nome_fantasia"
                label="Nome fantasia*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field-cnpj
                outlined
                label="CNPJ*"
                required=""
                :rules="[rules.required]"
                v-model="integrador.int_cnpj"
                v-bind:properties="{
                  readonly: false,
                  disabled: salvando,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                  loading: salvando
                }"
                v-bind:options="{
                  outputMask: '##############',
                  empty: null,
                  applyAfter: false,
                }"
              ></v-text-field-cnpj>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field-cep
                v-model="integrador.int_cep"
                label="CEP*"
                :rules="[rules.required]"
                :loading="loadingCep || salvando"
                :disabled="loadingCep || salvando"
                @change="searchCep(integrador.int_cep)"
                v-bind:properties="{
                  disabled: false,
                  outlined: true,
                  clearable: true,
                  placeholder: '',
                }"
                v-bind:options="{
                  outputMask: '########',
                  empty: null,
                  applyAfter: false,
                }"
              />
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                v-model="integrador.int_uf"
                autocomplete="off"
                :items="estados"
                :rules="[rules.required]"
                :loading="salvando || loadingEstados || loadingCep"
                :disabled="salvando || loadingEstados || loadingCep"
                label="Estado*"
                append-icon="expand_more"
                outlined
                @change="filterCidade(integrador.int_uf)"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-autocomplete
                autocomplete="off"
                v-model="integrador.int_cidade"
                :items="cidadesFiltradas"
                :loading="salvando || loadingCidades || loadingCep"
                :disabled="salvando || loadingCidades || loadingCep"
                label="Cidade*"
                :rules="[rules.required]"
                append-icon="expand_more"
                outlined
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="integrador.int_bairro"
                outlined
                :rules="[rules.required]"
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Bairro*"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="integrador.int_rua"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                :rules="[rules.required]"
                label="Rua*"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="2" md="2" lg="2" xl="2" class="pb-0 pt-0">
              <v-text-field
                v-model="integrador.int_numero"
                outlined
                :loading="salvando || loadingCep"
                :rules="[rules.required]"
                :disabled="salvando || loadingCep"
                label="Número*"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0 pt-0">
              <v-text-field
                v-model="integrador.int_complemento"
                outlined
                :loading="salvando || loadingCep"
                :disabled="salvando || loadingCep"
                label="Complemento"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="integrador.int_telefone"
                label="Telefone*"
                :loading="salvando"
                :rules="[rules.required]"
                :disabled="salvando"
                outlined
                v-mask="'(##) #####-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pb-0 pt-0">
              <v-text-field
                v-model="integrador.int_celular"
                label="Celular"
                :loading="salvando"
                :disabled="salvando"
                outlined
                v-mask="'(##) #####-####'"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4" lg="4" xl="4" class="pt-0">
              <v-text-field
                v-model="integrador.int_email"
                label="E-mail"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="integrador.int_imagem && !isObject(integrador.int_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div>
                  <div class="ui-avatar" :style="`background-image: url('${integrador && integrador.int_imagem ? integrador.int_imagem : require('@/assets/img/logo-icon.png')}')`"></div>
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagemIntegrador = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover imagem</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
            <v-col cols="12" sm="5" md="5" lg="5" xl="5" class="pt-0" v-else>
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="integrador.int_imagem"
                prepend-icon="image"
                label="Adicionar imagem"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(integrador.int_imagem)"
                outlined
              ></v-file-input>
            </v-col>
            <!-- <v-col cols="12"
              sm="4"
              md="4"
              lg="4"
              xl="4"
              class="pt-0 mb-5"
            >
              <div class="ui-file-image-empresa">
                <span class="img_adicione" v-if="!url">Adicione a logomarca</span>
                <div v-if="url" class="ui-image--contain" :style="'background-image: url(' +url+ ')'"></div>
                <input type="file" class="file" @change="onFileChange" />
              </div>
            </v-col> -->
          </v-row>
         </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialog()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditIntegrador()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagemIntegrador" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagemIntegrador = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover a imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagemIntegrador = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagemintegrador()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluir" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir Integrador
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelIntegradorDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir Integrador <b class="text-primary">{{integrador ? integrador.int_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelIntegradorDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeIntegrador()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogUsuarios"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            Usuários
          </v-col>
          <v-col cols="3" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <v-btn @click="dialogNovoUsuario = true" color="primary" class="mr-3">Novo Usuário</v-btn>
              <v-icon @click="closeUsuariosLista()">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersUsuarios"
            :items="dadosUsuarios"
            :search="searchUsuarios"
            multi-sort
            fixed-header
            height="400px"
            :loading="loadingIntegradorUsuarios"
            loading-text="Carregando... Por favor aguarde"
            class="elevation-1 base_table"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchUsuarios"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="exportXls('usuarios')">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item @click="exportPdf('usuarios')">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para PDF</v-list-item-title>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-row no-gutters align="center" justify="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openNovoUsuario(item)" color="primary" class="mr-2">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteUsuarios(item)" color="primary" class="ml-2">
                      delete
                    </v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="closeUsuariosLista()"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirUsuario" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir usuário
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="cancelUsuarioDelete()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir usuário <b class="text-primary">{{usuario ? usuario.usu_nome : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="cancelUsuarioDelete()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :disabled="salvando"
            :loading="salvando"
            @click="removeUser()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovoUsuario"
      persistent
      max-width="500px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{usuario.uuid_usu_id ? 'Editar' : 'Novo'}} usuário
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogUsuarios()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formUsuario">
         <v-row>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-autocomplete
                :menu-props="{ offsetY: true}"
                v-model="usuario.uuid_gru_id"
                :items="modulos"
                clearable
                clear-icon="close"
                label="Grupo*"
                :rules="[rules.required]"
                append-icon="expand_more"
                :loading="salvando || loadingGroups"
                :disabled="salvando || loadingGroups"
                outlined
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pb-0">
              <v-text-field
                v-model="usuario.usu_nome"
                label="Nome*"
                autofocus
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="usuario.usu_email"
                label="E-mail*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6" lg="6" xl="6" class="pt-0 pb-0">
              <v-text-field
                v-model="usuario.usu_apelido"
                label="Usuário*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-text-field
                @click:append="show1 = !show1"
                :label="usuario.uuid_usu_id ? 'Preencha caso desejar alterar a senha' : 'Senha*'"
                hint="Mínimo 6 caracteres"
                counter
                outlined
                :loading="salvando"
                :disabled="salvando"
                :type="show1 ? 'text' : 'password'"
                v-model="usuario.password"
                :append-icon="show1 ? 'remove_red_eye' : 'visibility_off'"
                :rules="usuario.uuid_usu_id ? [] : [rules.required, rules.min]"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-file-input
                show-size
                clearable
                ref="file"
                v-model="usuario.usu_imagem"
                prepend-icon="image"
                label="Adicionar imagem"
                clear-icon="close"
                truncate-length="50"
                :loading="salvando"
                :disabled="salvando"
                v-if="isObject(usuario.usu_imagem)"
                outlined
              ></v-file-input>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0 mb-6" v-if="usuario.usu_imagem && !isObject(usuario.usu_imagem)">
              <v-row no-gutters justify="start" align="center">
                <div>
                  <div class="avatar" :style="`background-image: url('${usuario && usuario.usu_imagem ? usuario.usu_imagem : require('@/assets/img/logo-icon.png')}')`"></div>
                </div>
                <div>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="dialogDeletarImagem = true" v-bind="attrs" v-on="on" color="primary">delete</v-icon>
                    </template>
                    <span>Remover imagem</span>
                  </v-tooltip>
                </div>
              </v-row>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogUsuarios()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditUser()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeletarImagem" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Remover Imagem
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="dialogDeletarImagem = false">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja remover a imagem?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="dialogDeletarImagem = false"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="success"
            :loading="salvando"
            :disabled="salvando"
            @click="removeImagem()"
          >
            Remover
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogAPI"
      persistent
      max-width="1000px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="9">
            API
          </v-col>
          <v-col cols="3" class="text-right">
            <v-row no-gutters align="center" justify="end">
              <v-btn @click="dialogNovaAPI = true" color="primary" class="mr-3">Nova API</v-btn>
              <v-icon @click="closeDialogAPI()">close</v-icon>
            </v-row>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div>
          <v-data-table
            :headers="headersAPI"
            :items="dadosAPI"
            :search="searchAPI"
            multi-sort
            fixed-header
            height="400px"
            class="elevation-1 base_table"
            :loading="loadingAPIS"
            loading-text="Carregando... Por favor aguarde"
            :footer-props="{
              itemsPerPageOptions: [5,10,15,20,25,50,100],
              showFirstLastPage: true,
              firstIcon: 'skip_previous',
              lastIcon: 'skip_next',
              prevIcon: 'chevron_left',
              nextIcon: 'chevron_right'
            }"
            :header-props="{
              sortIcon: 'north',
            }"
          >
            <template v-slot:top>
              <v-row no-gutters align="center" justify="space-between">
                <div class="py-2 px-2 table_search_area">
                  <v-text-field
                    clearable
                    hide-details=""
                    clear-icon="close"
                    v-model="searchAPI"
                    outlined
                    label="Busca"
                  ></v-text-field>
                </div>
                <div>
                  <v-menu
                    bottom
                    center
                    offset-y
                    max-height="400"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <div v-bind="attrs" v-on="on">
                        Exportar
                        <v-icon>arrow_drop_down</v-icon>
                      </div>
                    </template>
                    <v-list>
                      <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">receipt_long</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para XLS</v-list-item-title>
                      </v-list-item>
                      <!-- <v-list-item @click="''">
                        <v-list-item-icon class="mr-1">
                          <v-icon color="primary">assignment</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Exportar para PDF</v-list-item-title>
                      </v-list-item> -->
                    </v-list>
                  </v-menu>
                </div>
              </v-row>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-row no-gutters align="center" justify="center">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openDialogAPI(item)" color="primary" class="mr-2">
                      edit
                    </v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-bind="attrs" v-on="on" @click="openDialogDeleteAPI(item)" color="primary" class="ml-2">
                      delete
                    </v-icon>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </v-row>
            </template>
          </v-data-table>
        </div>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            @click="closeDialogAPI()"
          >
            Fechar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExcluirAPI" max-width="400">
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            Excluir API
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogRemoveAPI()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <div class="text-h3 mb-5">
          Tem certeza que deseja excluir API <b class="text-primary">{{api ? api.ina_api : ''}}</b>?
        </div>
        <v-divider class="mb-3"></v-divider>
        <v-row
          align="center"
          justify="space-between"
          class="px-5 py-5"
        >
          <v-btn
            color="cancel"
            :loading="salvando"
            :disabled="salvando"
            @click="closeDialogRemoveAPI()"
          >
            Cancelar
          </v-btn>
          <v-btn
            :loading="salvando"
            :disabled="salvando"
            color="success"
            @click="removeAPI()"
          >
            Excluir
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialogNovaAPI"
      persistent
      max-width="400px"
    >
      <v-card class="ui-dialog-top">
        <v-row align="center" justify="space-between">
          <v-col cols="10">
            {{api.uuid_ina_id ? 'Editar' : 'Nova'}} API
          </v-col>
          <v-col cols="2" class="text-right">
            <v-icon @click="closeDialogNovaAPI()">close</v-icon>
          </v-col>
        </v-row>
      </v-card>
      <v-card class="ui-dialog-content">
        <v-form ref="formAPI">
          <v-row>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0">
              <v-text-field
                v-model="api.ina_usuario"
                label="Usuário*"
                :rules="[rules.required]"
                autofocus
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="api.ina_api"
                label="API de acesso*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pb-0 pt-0">
              <v-text-field
                v-model="api.ina_senha"
                label="Senha*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="12" md="12" lg="12" xl="12" class="pt-0">
              <v-text-field
                v-model="api.ina_token"
                label="Token*"
                :rules="[rules.required]"
                outlined
                :disabled="salvando"
                :loading="salvando"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-divider></v-divider>
        <v-row no-gutters class="mt-4 mb-0" align="center" justify="space-between">
          <v-btn
            color="cancel"
            :disabled="salvando"
            :loading="salvando"
            @click="closeDialogNovaAPI()"
          >
            Cancelar
          </v-btn>
          <v-btn
            color="primary"
            @click="saveEditAPI()"
            :loading="salvando"
            :disabled="salvando"
          >
            Salvar
          </v-btn>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Api from '@API'
import axios from 'axios'
import { VueEditor } from 'vue2-editor'
import RelatorioBase from '@components/impressoes/RelatorioBase.vue'

export default {
  components: {
    VueEditor
  },
  data () {
    return {
      nivelUsuarioApelido: '',
      loading: true,
      salvando: false,
      dialogNovo: false,
      dialogUsuarios: false,
      dialogExcluir: false,
      dialogExcluirUsuario: false,
      dialogNovoUsuario: false,
      loadingCep: false,
      estados: [],
      cidades: [],
      cidadesFiltradas: [],
      loadingEstados: false,
      loadingCidades: false,
      show1: false,
      dialogAPI: false,
      dialogNovaAPI: false,
      dialogDeletarImagem: false,
      rules: {
        required: value => !!value || 'Obrigatório.',
        min: v => v.length >= 6 || 'Mínimo 6 caracteres'
      },
      search: '',
      searchFinal: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'int_id'
        },
        { text: 'Integrador', value: 'int_nome' },
        { text: 'Distribuidor', value: 'distribuidor.dis_nome' },
        { text: 'Nome fantasia', value: 'int_nome_fantasia' },
        { text: 'Telefone', value: 'int_telefone' },
        { text: 'Celular', value: 'int_celular' },
        // {
        //   text: 'API',
        //   value: 'api',
        //   align: 'center',
        //   sortable: false,
        //   width: 60
        // },
        {
          text: 'Usuários',
          value: 'users',
          align: 'center',
          sortable: false,
          width: 60
        },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dados: [],
      searchUsuarios: '',
      headersUsuarios: [
        {
          text: 'ID',
          align: 'start',
          value: 'usu_id'
        },
        { text: 'Nome', value: 'usu_nome' },
        { text: 'E-mail', value: 'usu_email' },
        { text: 'Usuário', value: 'usu_apelido' },
        { text: 'Módulo', value: 'modulo' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      dadosUsuarios: [],
      url: '',
      usuario: {
        uuid_gru_id: '',
        usu_nome: '',
        usu_email: '',
        usu_apelido: '',
        usu_imagem: '',
        password: ''
      },
      modulos: [],
      distribuidores: [],
      distribuidor: null,
      loadingIntegradorUsuarios: false,
      integradorID: '',
      integrador: {
        int_nome: '',
        int_nome_fantasia: '',
        int_cnpj: '',
        int_cep: '',
        int_uf: '',
        int_cidade: '',
        int_bairro: '',
        int_rua: '',
        int_numero: '',
        int_complemento: '',
        int_telefone: '',
        int_celular: '',
        int_email: '',
        int_imagem: ''
      },
      searchAPI: '',
      dadosAPI: [],
      dialogDeletarImagemIntegrador: false,
      headersAPI: [
        {
          text: 'ID',
          align: 'start',
          value: 'ina_id'
        },
        { text: 'Usuário', value: 'ina_usuario' },
        { text: 'API', value: 'ina_api' },
        { text: 'Token', value: 'ina_token' },
        {
          text: 'Ações',
          value: 'actions',
          align: 'center',
          sortable: false,
          width: 110
        }
      ],
      loadingAPIS: false,
      dialogExcluirAPI: false,
      api: {
        ina_usuario: '',
        ina_api: '',
        ina_senha: '',
        ina_token: ''
      },
      loadingXls: false
    }
  },
  methods: {
    async exportXls (type = null) {
      this.loadingXls = true
      Api.post('relatorios', {
        distribuidor: !type ? this.distribuidor : null,
        headers: this.someHeader(!type ? this.headers : this.headersUsuarios),
        integrador: this.integradorID,
        busca: !type ? this.searchFinal : this.searchUsuarios,
        type: !type ? 'integrador' : 'integrador-usuarios'
      })
        .then(res => {
          const baseUrl = window.location.origin
          this.downloadXls(baseUrl + '/' + res.data.url)
          this.removeXls(res.data.url)
          this.loadingXls = false
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Ops, ocorreu um erro ao fazer o donwload!',
            color: 'error'
          })
        })
    },
    async downloadXls (url) {
      const a = document.createElement('a')
      a.href = url
      a.download = url.split('/').pop()
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    },
    removeXls (url) {
      let data = {
        url: url
      }
      Api.post('relatorios/remove-s3', data)
    },
    exportPdf (type = null) {
      this.$root.Printer.openDialog(this, {
        titulo: !type ? 'Integradores' : 'Usuários', // Título que aparece centralizado na página e como nome do dialog
        component: RelatorioBase, // componente com o layout a ser impresso
        data: !type ? this.dados : this.dadosUsuarios,
        headers: this.someHeader(!type ? this.headers : this.headersUsuarios), // dados para alimentar o componente, por padrão ele chegará como o props data no componente
        css: `` // Classes css que são adicionados na página de impressão
      })
    },
    someHeader (model) {
      let cabecalhos = []
      model.map(header => {
        if (header.text !== 'ID' && header.text !== 'Ações' && header.text !== 'Usuários') cabecalhos.push(header)
      })
      return cabecalhos
    },
    loadFunctions () {
      let filters = this.$route.query
      if (filters.distribuidor) this.distribuidor = filters.distribuidor
      if (filters.busca) {
        this.searchFinal = filters.busca
        this.search = filters.busca
      }
      this.getCidade()
      this.getEstados()
      this.getIntegradores()
      this.getDistribuidores()
      this.getGroups()
    },
    isObject (val) {
      if (val && val !== '') {
        return val instanceof Object
      } else {
        return true
      }
    },
    async getGroups () {
      this.loadingGroups = true
      await Api.get('grupos')
        .then(res => {
          var arrayGroups = []
          res.data.map(gru => {
            arrayGroups.push({
              'text': gru.gru_nome,
              'value': gru.uuid_gru_id
            })
          })
          this.modulos = arrayGroups
          this.loadingGroups = false
        })
        .catch(err => {
          this.loadingGroups = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os grupos!',
            color: 'error'
          })
          console.log(err)
        })
    },
    limparBusca () {
      this.searchFinal = ''
      this.search = ''
      this.applyBusca()
    },
    applyBusca () {
      this.searchFinal = this.search

      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.searchFinal ? { busca: this.searchFinal } : ''
      )

      this.$router.replace({name: 'Integrador', query: query}).catch(() => {})
    },
    applyFilter () {
      let query = Object.assign({},
        this.distribuidor ? { distribuidor: this.distribuidor } : '',
        this.searchFinal ? { busca: this.searchFinal } : ''
      )

      this.$router.replace({name: 'Integrador', query: query}).catch(() => {})
      this.getIntegradores()
    },
    async getDistribuidores () {
      this.loadingDistribuidores = true
      await Api.get('distribuidores')
        .then(res => {
          let distribuidores = res.data
          const user = JSON.parse(localStorage.getItem('user'))

          if (this.nivelUsuarioApelido === 'D') {
            distribuidores = distribuidores.filter(distribuidor => distribuidor.dis_id === user.fk_dis_id_distribuidor)
          }

          const arrayDists = []
          distribuidores.map(dist => {
            arrayDists.push({
              'text': dist.dis_nome,
              'value': dist.uuid_dis_id
            })
          })
          this.distribuidores = arrayDists
          this.loadingDistribuidores = false
        })
        .catch(err => {
          this.loadingDistribuidores = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os distribuidores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    async getIntegradores () {
      this.loading = true
      let url = 'integradores'

      if (this.distribuidor) {
        url = `integradores/distribuidor/${this.distribuidor}`
      }

      await Api.get(url)
        .then(res => {
          this.dados = res.data
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os integradores!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeImagemintegrador () {
      this.integrador.int_imagem = ''
      this.integrador.remover_imagem = true
      this.dialogDeletarImagemIntegrador = false
    },
    saveEditIntegrador () {
      if (!this.$refs.formIntegrador.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'integradores/novo'
      let editado = false
      if (this.integrador.uuid_int_id) {
        endpoint = 'integradores/edita'
        editado = true
      }
      const formData = new FormData()
      Object.keys(this.integrador).map((key) => {
        if (key === 'imagem') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`imagem`, this.integrador.int_imagem[0].file)
            }
          }
        } else if (key === 'distribuidor') {
          formData.append('distribuidor', JSON.stringify(this.integrador.distribuidor))
        } else {
          if (this.integrador[key] != null) {
            formData.append(key, this.integrador[key])
          }
        }
      })
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Integrador atualizado com sucesso!' : 'Integrador cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialog()
          this.getIntegradores()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    openIntegrador (item) {
      this.salvando = true
      this.dialogNovo = true
      Api.get('integradores/' + item.uuid_int_id)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          if (response.data.int_uf) {
            this.filterCidade(response.data.int_uf)
          }
          this.integrador = JSON.parse(JSON.stringify(response.data))
          this.integrador.uuid_dis_id = response.data.distribuidor.uuid_dis_id
        })
        .catch((error) => {
          this.salvando = false
          this.dialogNovo = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro ao carregar dados do integrador!',
            color: 'error'
          })
        })
    },
    onFileChange (e) {
      this.integrador.logo = e.target.files[0]
      this.url = URL.createObjectURL(this.integrador.logo)
    },
    openDialogDelete (item) {
      this.integrador = JSON.parse(JSON.stringify(item))
      this.dialogExcluir = true
    },
    cancelIntegradorDelete () {
      this.closeDialog()
      this.dialogExcluir = false
    },
    removeIntegrador () {
      this.salvando = true
      Api.delete(`integradores/remove/${this.integrador.uuid_int_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluir = false
          this.salvando = false
          this.closeDialog()
          this.getIntegradores()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover integrador!',
            color: 'error'
          })
        })
    },
    openUsuarios (item) {
      this.integradorID = item.uuid_int_id
      this.dialogUsuarios = true
      this.getUsuariosIntegrador()
    },
    async getUsuariosIntegrador () {
      this.loadingIntegradorUsuarios = true
      await Api.get('usuarios/integrador/' + this.integradorID)
        .then(res => {
          if (res.data && res.data.length > 0) {
            let info = []
            res.data.map(item => {
              info.push({
                usu_id: item.usu_id,
                usu_nome: item.usu_nome,
                usu_imagem: item.usu_imagem,
                usu_email: item.usu_email,
                usu_apelido: item.usu_apelido,
                modulo: item.grupo ? item.grupo.gru_nome : null,
                uuid_gru_id: item.grupo ? item.grupo.uuid_gru_id : null,
                uuid_usu_id: item.uuid_usu_id
              })
            })
            this.dadosUsuarios = info
          } else {
            this.dadosUsuarios = []
          }
          this.loadingIntegradorUsuarios = false
        })
        .catch(err => {
          console.log(err)

          this.loadingIntegradorUsuarios = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os usuários!',
            color: 'error'
          })
        })
    },
    openNovoUsuario (item) {
      this.usuario = JSON.parse(JSON.stringify(item))
      this.dialogNovoUsuario = true
    },
    cancelUsuarioDelete () {
      this.closeDialogUsuarios()
      this.dialogExcluirUsuario = false
    },
    removeImagem () {
      this.usuario.usu_imagem = ''
      this.usuario.remover_imagem = true
      this.dialogDeletarImagem = false
    },
    saveEditUser () {
      if (!this.$refs.formUsuario.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'usuarios/novo'
      let editado = false
      this.usuario.uuid_int_id = this.integradorID
      if (this.$refs.file) {
        this.usuario.imagem = this.$refs.file.fileRecords
      }
      const formData = new FormData()
      Object.keys(this.usuario).map((key) => {
        if (key === 'imagem') {
          if (this.$refs.file) {
            if (this.$refs.file.fileRecords && this.$refs.file.fileRecords.length > 0) {
              formData.append(`imagem`, this.usuario.usu_imagem[0].file)
            }
          }
        } else {
          if (this.usuario[key] != null) {
            formData.append(key, this.usuario[key])
          }
        }
      })
      if (this.usuario.uuid_usu_id) {
        endpoint = 'usuarios/edita'
        editado = true
      }
      Api.post(endpoint, formData)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Usuário atualizado com sucesso!' : 'Usuário cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialogUsuarios()
          this.getUsuariosIntegrador()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    removeUser () {
      this.salvando = true
      Api.delete(`usuarios/remove/${this.usuario.uuid_usu_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluirUsuario = false
          this.salvando = false
          this.closeDialogUsuarios()
          this.getUsuariosIntegrador()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover usuário!',
            color: 'error'
          })
        })
    },
    closeUsuariosLista () {
      this.integradorID = ''
      this.dadosUsuarios = []
      this.dialogUsuarios = false
    },
    openDialogDeleteUsuarios (item) {
      this.usuario = JSON.parse(JSON.stringify(item))
      this.dialogExcluirUsuario = true
    },
    closeDialogUsuarios () {
      if (this.$refs.formUsuario) {
        this.$refs.formUsuario.resetValidation()
      }
      this.dialogNovoUsuario = false
      this.usuario = {
        uuid_gru_id: '',
        usu_nome: '',
        usu_email: '',
        usu_apelido: '',
        usu_imagem: '',
        password: ''
      }
    },
    closeDialog () {
      this.integrador = {
        int_nome: '',
        int_nome_fantasia: '',
        int_cnpj: '',
        int_cep: '',
        int_uf: '',
        int_cidade: '',
        int_bairro: '',
        int_rua: '',
        int_numero: '',
        int_complemento: '',
        int_telefone: '',
        int_celular: '',
        int_email: '',
        int_imagem: ''
      }
      if (this.$refs.formIntegrador) {
        this.$refs.formIntegrador.resetValidation()
      }
      this.dialogNovo = false
    },
    searchCep (cep = '') {
      if (cep.length === 8) {
        this.loadingCep = true
        axios.get('https://viacep.com.br/ws/' + cep + '/json/')
          .then((response) => {
            if (!response.data.erro) {
              this.integrador.int_rua = response.data.logradouro
              this.integrador.int_bairro = response.data.bairro
              this.integrador.int_complemento = response.data.complemento
              if (response.data.uf) {
                this.integrador.int_uf = response.data.uf
                this.integrador.int_cidade = response.data.localidade
                this.filterCidade(response.data.uf)
              }
            }
          })
          .catch(err => {
            console.log(err)
            this.$root.SnackControl.open(this, {
              text: 'Erro ao buscar por CEP!',
              color: 'error'
            })
          }).finally(() => {
            this.loadingCep = false
          })
      }
    },
    getEstados () {
      this.loadingEstados = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome')
        .then((response) => {
          for (let estado = 0; estado < response.data.length; estado++) {
            this.estados.push({
              text: response.data[estado].nome,
              value: response.data[estado].sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar os estados!',
            color: 'error'
          })
        })
      this.loadingEstados = false
    },
    getCidade () {
      this.loadingCidades = true
      axios.get('https://servicodados.ibge.gov.br/api/v1/localidades/municipios')
        .then((response) => {
          for (let cidade = 0; cidade < response.data.length; cidade++) {
            this.cidades.push({
              text: response.data[cidade].nome,
              value: response.data[cidade].nome,
              uf: response.data[cidade].microrregiao.mesorregiao.UF.sigla
            })
          }
        })
        .catch(err => {
          console.log(err)
          this.$root.SnackControl.open(this, {
            text: 'Erro ao buscar as cidades!',
            color: 'error'
          })
        })
      this.loadingCidades = false
    },
    filterCidade (estado) {
      this.cidadesFiltradas = this.cidades.filter(city => city.uf === estado)
    },
    openAPIS (item) {
      this.integradorID = item.uuid_int_id
      this.dialogAPI = true
      this.getAPI()
    },
    async getAPI () {
      this.loadingAPIS = true
      await Api.get('apis/integrador/' + this.integradorID)
        .then(res => {
          if (res.data && res.data.length > 0) {
            this.dadosAPI = res.data
          } else {
            this.dadosAPI = []
          }
          this.loadingAPIS = false
        })
        .catch(err => {
          this.loadingAPIS = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar as APIS!',
            color: 'error'
          })
          console.log(err)
        })
    },
    closeDialogAPI () {
      this.integradorID = ''
      this.dialogAPI = false
    },
    closeDialogNovaAPI () {
      this.api = {
        ina_usuario: '',
        ina_api: '',
        ina_senha: '',
        ina_token: ''
      }
      if (this.$refs.formAPI) {
        this.$refs.formAPI.resetValidation()
      }
      this.dialogNovaAPI = false
    },
    openDialogAPI (item) {
      this.api = JSON.parse(JSON.stringify(item))
      this.dialogNovaAPI = true
    },
    openDialogDeleteAPI (item) {
      this.api = JSON.parse(JSON.stringify(item))
      this.dialogExcluirAPI = true
    },
    saveEditAPI () {
      if (!this.$refs.formAPI.validate()) {
        this.$root.SnackControl.open(this, {
          text: 'Por favor, preencha os campos corretamente.',
          color: 'warning'
        })
        return
      }
      this.salvando = true
      let endpoint = 'apis/novo'
      let editado = false
      if (this.api.uuid_ina_id) {
        endpoint = 'apis/edita'
        editado = true
      }
      this.api.uuid_int_id = this.integradorID
      Api.post(endpoint, this.api)
        .then((response) => {
          this.salvando = false
          if (response.data.error) {
            this.$root.SnackControl.open(this, {
              text: response.data.error,
              color: 'error'
            })
            return false
          }
          this.$root.SnackControl.open(this, {
            text: editado ? 'Usuário atualizado com sucesso!' : 'Usuário cadastrado com sucesso!',
            color: 'success'
          })
          this.closeDialogNovaAPI()
          this.getAPI()
        })
        .catch((error) => {
          this.salvando = false
          console.log(error.response)
          this.$root.SnackControl.open(this, {
            text: error.response ? error.response.data.message : 'Ops! Ocorreu um erro!',
            color: 'error'
          })
        })
    },
    closeDialogRemoveAPI () {
      this.closeDialogNovaAPI()
      this.dialogExcluirAPI = false
    },
    removeAPI () {
      this.salvando = true
      Api.delete(`apis/remove/${this.api.uuid_ina_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.message
          })
          this.dialogExcluirAPI = false
          this.salvando = false
          this.closeDialogRemoveAPI()
          this.getAPI()
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover API!',
            color: 'error'
          })
        })
    },
    updateData () {
      if (JSON.parse(localStorage.getItem('user')) !== null && !this.user) {
        let user = JSON.parse(localStorage.getItem('user'))
        if (user.fk_gru_id_grupo) {
          this.nivelUsuarioApelido = 'M'
        }
        if (user.fk_dis_id_distribuidor) {
          this.nivelUsuarioApelido = 'D'
        }
        if (user.fk_int_id_integrador) {
          this.nivelUsuarioApelido = 'I'
        }
      }
    }
  },
  updated () {
    this.updateData()
  },
  created () {
    this.updateData()
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>> .v-text-field--outlined .v-input__append-outer, .v-text-field--outlined .v-input__prepend-outer {
  margin-top: 8px!important;
}
.mw_600 {
  max-width: 600px;
}
.max-height_dialog {
  overflow: auto;
  max-height: 400px;
}
.avatar {
  background-position: center top;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 100%;
  height: 80px;
  margin-right: 15px;
  width: 80px;
}
.v-file-input {
  >>>.v-input__prepend-outer {
    margin-top: 10px!important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cadastros/Integrador.vue